import { timeDay, timeFormat, timeHour, timeMinute, timeMonth, timeSecond, timeWeek, timeYear } from 'd3';
const formatNumberAbbreviated = value => {
  if (value === null) {
    return 'null';
  }
  let numberValue;
  if (typeof value === 'string') {
    const parsedValue = Number(value);
    if (isNaN(parsedValue)) {
      return value;
    }
    numberValue = parsedValue;
  } else {
    numberValue = value;
  }
  return new Intl.NumberFormat('en-US', {
    notation: 'compact',
    compactDisplay: 'short'
  }).format(numberValue);
};
const percentChange = (currentValue, previousValue) => {
  if (previousValue === 0) {
    return (currentValue * 100).toFixed();
  }
  return (Math.abs(previousValue - currentValue) / previousValue * 100).toFixed();
};
const formatMillisecond = timeFormat('.%L'),
  formatSecond = timeFormat(':%S'),
  formatMinute = timeFormat('%I:%M'),
  formatHour = timeFormat('%I %p'),
  formatDay = timeFormat('%b %d'),
  formatWeek = timeFormat('%b %d'),
  formatMonth = timeFormat('%b'),
  formatYear = timeFormat('%Y');

// Default tickFormat behavior for d3-axis on temporal scales.
export function multiTimeFormat(date) {
  return (timeSecond(date) < date ? formatMillisecond : timeMinute(date) < date ? formatSecond : timeHour(date) < date ? formatMinute : timeDay(date) < date ? formatHour : timeMonth(date) < date ? timeWeek(date) < date ? formatDay : formatWeek : timeYear(date) < date ? formatMonth : formatYear)(date);
}
export function toSentenceCase(str) {
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
}
export default {
  formatNumberAbbreviated,
  percentChange,
  multiTimeFormat,
  toSentenceCase
};